import { render } from "./ResetWaitForm.vue?vue&type=template&id=64ef3264&scoped=true&ts=true"
import script from "./ResetWaitForm.vue?vue&type=script&lang=ts"
export * from "./ResetWaitForm.vue?vue&type=script&lang=ts"

import "./ResetWaitForm.vue?vue&type=style&index=0&id=64ef3264&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ef3264"]])

export default __exports__